export enum Locale {
    EN = "en",
    RU = "ru"
}